var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    getMessageThreadsState: {
        loading: true,
        error: undefined,
    },
    createMessageThreadState: {
        loading: false,
        success: false,
        error: undefined,
    },
    saveEmailState: {
        loading: false,
        success: false,
    },
    email: undefined,
    isFramMember: undefined,
    records: undefined,
};
export var threadSlice = createSlice({
    name: 'messageThreads',
    initialState: initialState,
    reducers: {
        clearMessageThreads: function (state) {
            state.records = undefined;
        },
        clearCreateMessageThread: function (state) {
            state.createMessageThreadState.success = false;
            state.createMessageThreadState.error = undefined;
        },
        createMessageThreadRequested: function (state, action) {
            state.createMessageThreadState.loading = true;
            state.createMessageThreadState.success = false;
        },
        createMessageThreadSucceeded: function (state, action) {
            state.createMessageThreadState.loading = false;
            state.createMessageThreadState.success = true;
            state.records =
                state.records === undefined
                    ? [action.payload]
                    : __spreadArray([action.payload], state.records, true);
        },
        createMessageThreadFailed: function (state, action) {
            state.createMessageThreadState.loading = false;
            state.createMessageThreadState.success = false;
            state.createMessageThreadState.error = action.payload;
        },
        getCustomerInfoRequested: function (state) {
            state.email = undefined;
            state.isFramMember = undefined;
        },
        getCustomerInfoSucceeded: function (state, action) {
            state.email = action.payload.email;
            state.isFramMember = action.payload.isFramMember;
        },
        getMessageThreadsRequested: function (state, action) {
            state.getMessageThreadsState.loading = true;
        },
        getMessageThreadsSucceeded: function (state, action) {
            state.getMessageThreadsState.loading = false;
            state.records = action.payload.content;
        },
        getMessageThreadsFailed: function (state, action) {
            state.getMessageThreadsState.loading = false;
            state.getMessageThreadsState.error = action.payload;
        },
        saveEmailRequested: function (state, action) {
            state.saveEmailState.loading = true;
            state.saveEmailState.error = undefined;
        },
        saveEmailSucceeded: function (state) {
            state.saveEmailState.loading = false;
            state.saveEmailState.success = true;
        },
        saveEmailFailed: function (state, action) {
            state.saveEmailState.loading = false;
            state.saveEmailState.error = action.payload;
        },
    },
});
export var clearMessageThreads = (_a = threadSlice.actions, _a.clearMessageThreads), clearCreateMessageThread = _a.clearCreateMessageThread, createMessageThreadRequested = _a.createMessageThreadRequested, createMessageThreadSucceeded = _a.createMessageThreadSucceeded, createMessageThreadFailed = _a.createMessageThreadFailed, getMessageThreadsRequested = _a.getMessageThreadsRequested, getMessageThreadsSucceeded = _a.getMessageThreadsSucceeded, getMessageThreadsFailed = _a.getMessageThreadsFailed, getCustomerInfoRequested = _a.getCustomerInfoRequested, getCustomerInfoSucceeded = _a.getCustomerInfoSucceeded, saveEmailRequested = _a.saveEmailRequested, saveEmailSucceeded = _a.saveEmailSucceeded, saveEmailFailed = _a.saveEmailFailed;
export default threadSlice.reducer;
